
/* assets/rate-chart.js
   Quote restoration + Option A summary fix.
   Compatible with the current rate-chart Liquid markup.

   Production build (diagnostics removed). Requires
   data-item-id="{{ item.system.id }}" on each .rate-chart__row
   in rate-chart.liquid, since Shopify metaobjects expose their
   ID under `.system.id`, not `.id`.
*/

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('rate-chart-section');
  if (!root) return;

  const calcEnabled = root.dataset.enableCalc === 'true';
  const orderEnabled = root.dataset.enableOrder === 'true';
  const quoteEnabled = root.dataset.enableQuote === 'true';
  const location = document.getElementById('rc-location');
  const delivery = document.getElementById('rc-delivery-date');
  const returnDate = document.getElementById('rc-return-date');
  const addButton = document.getElementById('rc-add-to-cart');
  const rows = () => [...document.querySelectorAll('.rate-chart__row')];
  let cityData = [];

  const dateText = d => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
  const days = () => calcEnabled && location?.value && delivery?.value && returnDate?.value ? Math.max(Math.round((new Date(returnDate.value)-new Date(delivery.value))/86400000)+1,0) : 0;
  const unit = row => row.dataset.unit || 'item';
  const quantity = row => Math.max(1, Math.min(25, parseInt(row.querySelector('.rc-quantity')?.value,10)||1));

  function calculate(row) {
    const d = days();
    const daily = parseFloat(row.dataset.dailyRate)||0;
    const flat = parseFloat(row.dataset.defaultCharge)||0;
    const defaultDays = parseInt(row.dataset.defaultDays,10)||0;
    const baseDeposit = parseFloat(row.dataset.deposit)||0;
    const qty = quantity(row);
    const baseCost = row.dataset.rentalType === 'Daily rental rate' ? (d ? (d <= defaultDays ? flat : daily*d) : 0) : flat;
    const cost = baseCost*qty;
    const deposit = baseDeposit*qty;
    return { qty, baseCost, baseDeposit, cost, deposit, refund: Math.max(deposit-cost,0), baseRefund: Math.max(baseDeposit-baseCost,0) };
  }

  function render() {
    const valid = Boolean(location?.value && delivery?.value && returnDate?.value);
    document.querySelectorAll('.rate-chart__select-item,.rc-quantity').forEach(control => {
      control.disabled = !valid;
      if (!valid && control.classList.contains('rate-chart__select-item')) control.checked = false;
    });
    if (addButton) addButton.disabled = !valid;

    let totalCost=0,totalDeposit=0;
    rows().forEach(row => {
      const checkbox=row.querySelector('.rate-chart__select-item');
      const summary=row.querySelector('[data-role="row-summary"]');
      if (!valid) { summary.textContent='Select location and dates'; }
      else if (!checkbox.checked) { summary.textContent='—'; }
      else {
        const x=calculate(row);
        summary.innerHTML =
          `<span><b>Quantity:</b> ${x.qty} ${unit(row)} for ${days()} day(s)</span>` +
          `<span><b>Security deposit payable by you now:</b> ₹${x.deposit.toFixed(0)}</span>` +
          `<span><b>Usage cost deducted from deposit:</b> ₹${x.cost.toFixed(0)}</span>` +
          `<span><b>Refund back to you:</b> ₹${x.refund.toFixed(0)}</span>`;
      }
      if(valid&&checkbox.checked){const x=calculate(row);totalCost+=x.cost;totalDeposit+=x.deposit;}
    });
    const set=(id,value)=>{const e=document.getElementById(id);if(e)e.textContent=value;};
    set('rc-days',days());set('rc-total-cost',totalCost.toFixed(0));set('rc-pay-now',totalDeposit.toFixed(0));set('rc-refund',Math.max(totalDeposit-totalCost,0).toFixed(0));
  }

  async function loadLocations() {
    if(!location) return;
    try { const response=await fetch(root.dataset.cityJsonUrl,{cache:'no-cache'}); if(!response.ok)throw Error(); const data=await response.json(); cityData=Array.isArray(data)?data:(data.locations||[]); }
    catch(e){ cityData=[{city:'Other',dmc_lead_time_days:5,city_lead_time_days:0}]; }
    const old=location.value;
    location.innerHTML='<option value="">-- Search or Select Location --</option>';
    cityData.sort((a,b)=>(a.city||'').localeCompare(b.city||'')).forEach(entry=>{if(entry.city){const option=new Option(entry.city,entry.city);location.add(option);}});
    if(!cityData.some(x=>x.city==='Other'))location.add(new Option('Other','Other'));
    if(old)location.value=old;
  }

  function locationChanged() {
    delivery.value='';returnDate.value='';delivery.min='';returnDate.min='';returnDate.max='';
    if(!location.value){delivery.disabled=true;returnDate.disabled=true;render();return;}
    const data=cityData.find(x=>(x.city||'').toLowerCase()===location.value.toLowerCase())||{dmc_lead_time_days:7,city_lead_time_days:0};
    const earliest=new Date();earliest.setDate(earliest.getDate()+(+data.dmc_lead_time_days||7)+(+data.city_lead_time_days||0)+1);while(earliest.getDay()===0)earliest.setDate(earliest.getDate()+1);
    delivery.disabled=false;returnDate.disabled=true;delivery.min=dateText(earliest);document.getElementById('rc-earliest-line').textContent=`Earliest delivery at ${location.value}: ${earliest.toLocaleDateString('en-IN',{weekday:'short',year:'numeric',month:'short',day:'numeric'})}`;render();
  }

  function deliveryChanged(){
    if(!delivery.value){returnDate.disabled=true;returnDate.value='';render();return;}
    const d=new Date(delivery.value),min=new Date(d),max=new Date(d);min.setDate(min.getDate()+1);max.setDate(max.getDate()+60);returnDate.min=dateText(min);returnDate.max=dateText(max);returnDate.disabled=false;render();
  }

  function selectedRows(){return rows().filter(row=>row.querySelector('.rate-chart__select-item')?.checked).map(row=>{const x=calculate(row);return{row,itemId:row.dataset.itemId||'',itemName:row.dataset.itemName||row.querySelector('.rc-item-name')?.textContent.trim()||'',variantId:row.querySelector('.rate-chart__variant-select')?.value||'',...x};});}

  function restoreQuote(){
    const encoded=new URLSearchParams(window.location.search).get('rc_quote');if(!encoded)return;
    try{
      const payload=JSON.parse(decodeURIComponent(atob(encoded)));
      if(payload.location){location.value=payload.location;locationChanged();}
      if(payload.deliveryDate){delivery.value=payload.deliveryDate;deliveryChanged();}
      if(payload.returnDate)returnDate.value=payload.returnDate;

      const savedItems=Array.isArray(payload.items)?payload.items:[];
      const savedById=new Map(
        savedItems
          .filter(item=>item && item.itemId!==undefined && item.itemId!==null && String(item.itemId)!=='')
          .map(item=>[String(item.itemId).trim(), item])
      );

      rows().forEach(row=>{
        const checkbox=row.querySelector('.rate-chart__select-item');
        if(checkbox) checkbox.checked=false;
      });

      rows().forEach(row=>{
        const rowId=String(row.dataset.itemId||'').trim();
        if(!rowId || !savedById.has(rowId)) return;

        const saved=savedById.get(rowId);
        const checkbox=row.querySelector('.rate-chart__select-item');
        if(checkbox) checkbox.checked=true;

        const qty=row.querySelector('.rc-quantity');
        if(qty && saved.quantity) qty.value=Math.max(1,Math.min(25,parseInt(saved.quantity,10)||1));

        const variant=row.querySelector('.rate-chart__variant-select');
        if(variant && saved.variantId) variant.value=String(saved.variantId);
      });

      render();
    }catch(error){console.warn('Quote restoration failed',error);}
  }

  function sizeValidation(){let valid=true;let first=null;document.querySelectorAll('.rate-chart__select-item:checked').forEach(cb=>{const select=cb.closest('.rate-chart__row')?.querySelector('select.rate-chart__variant-select');if(select&&!select.value){select.classList.add('rc-size-error');valid=false;first=first||select;}});if(!valid){alert('Please select a size for each selected item.');first?.focus();}return valid;}

  document.querySelectorAll('.rate-chart__select-item').forEach(x=>x.addEventListener('change',render));
  document.querySelectorAll('.rc-quantity').forEach(x=>{x.addEventListener('change',render);x.addEventListener('input',render);});
  location?.addEventListener('change',locationChanged);
  delivery?.addEventListener('change',deliveryChanged);
  returnDate?.addEventListener('change',render);

  if(orderEnabled) addButton?.addEventListener('click', async () => {
    if(!location.value||!delivery.value||!returnDate.value){alert('Please select delivery location and both dates first.');return;}
    if(!sizeValidation())return;
    const items=selectedRows().filter(x=>x.variantId).map(x=>({
      id:x.variantId,
      quantity:x.qty,
      properties:{
        'Rental Days':days(),
        '_Quantity':x.qty,
        'Rental Cost':x.cost.toFixed(2),
        'Security Deposit':x.deposit.toFixed(2),
        'Expected Refund':x.refund.toFixed(2),
        '_base_rental_cost':x.baseCost.toFixed(2),
        '_base_deposit':x.baseDeposit.toFixed(2),
        '_base_refund':x.baseRefund.toFixed(2),
        'Rental Location':location.value,
        'Delivery Date':delivery.value,
        'Return Date':returnDate.value
      }
    }));
    if(!items.length){alert('Please select at least one item.');return;}
    try{
      const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
      if(!response.ok)throw Error();
      window.location.href='/cart';
    }catch(e){alert('Unable to add items to cart. Please try again.');}
  });

  function quoteLink(items){
    const payload={
      location:location.value,
      deliveryDate:delivery.value,
      returnDate:returnDate.value,
      items:items.map(x=>({itemId:x.itemId,itemName:x.itemName,variantId:x.variantId,quantity:x.qty}))
    };
    return `${window.location.origin}${window.location.pathname}?rc_quote=${btoa(encodeURIComponent(JSON.stringify(payload)))}`;
  }

  if(quoteEnabled){
    document.getElementById('rc-share-quote')?.addEventListener('click', () => {
      const items=selectedRows();
      if(!items.length){alert('Select at least one item first.');return;}
      let text=`Deccan Mountain Club Rental Quote\nLocation: ${location.value}\nDelivery: ${delivery.value} | Return: ${returnDate.value}\n\n`;
      items.forEach(x=>text+=`${x.itemName}\nQuantity: ${x.qty} ${unit(x.row)} for ${days()} day(s)\nSecurity deposit payable by you now: ₹${x.deposit.toFixed(0)}\nUsage cost deducted from deposit: ₹${x.cost.toFixed(0)}\nRefund back to you: ₹${x.refund.toFixed(0)}\n\n`);
      text+=`Review or update your selection, then click Add Selected to Cart.\n\nOpen your saved quote:\n${quoteLink(items)}`;
      if(navigator.share) navigator.share({title:'Deccan Mountain Club Rental Quote',text}).catch(()=>{});
      else window.open(`https://wa.me/?text=${encodeURIComponent(text)}`,'_blank','noopener');
    });

    document.getElementById('rc-download-pdf')?.addEventListener('click', async () => {
      const items=selectedRows();
      if(!items.length){alert('Select at least one item first.');return;}
      try{
        if(!window.jspdf){
          const script=document.createElement('script');
          script.src='https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
          document.head.appendChild(script);
          await new Promise((resolve,reject)=>{script.onload=resolve;script.onerror=reject;});
        }
        const {jsPDF}=window.jspdf, pdf=new jsPDF();
        let y=20;
        pdf.setFontSize(16);pdf.text('Deccan Mountain Club Rental Quote',14,y);y+=10;
        pdf.setFontSize(10);pdf.text(`Location: ${location.value}`,14,y);y+=6;
        pdf.text(`Delivery: ${delivery.value} | Return: ${returnDate.value}`,14,y);y+=10;
        items.forEach(x=>{
          const lines=pdf.splitTextToSize(`${x.itemName} | Quantity: ${x.qty} ${unit(x.row)} for ${days()} days | Deposit: Rs.${x.deposit.toFixed(0)} | Usage cost: Rs.${x.cost.toFixed(0)} | Refund: Rs.${x.refund.toFixed(0)}`,180);
          pdf.text(lines,14,y);y+=lines.length*5+3;
        });
        pdf.setTextColor(0,70,120);
        pdf.textWithLink('Review selection and complete order',14,y+8,{url:quoteLink(items)});
        pdf.save('deccan-mountain-club-rental-quote.pdf');
      }catch(e){console.error(e);alert('The PDF could not be generated. Please try again.');}
    });
  }
/* Tooltip wiring for rate-chart.js
   Paste this block into rate-chart.js, just before the final
   two lines:
     loadLocations().then(restoreQuote);
     render();

   This binds hover/focus/click behavior to every element carrying
   a data-tooltip attribute (the ⓘ info icons in rate-chart.liquid).
   The .rc-tooltip CSS class already exists in the Liquid file's
   <style> block; this only creates and positions the element.
*/

let rcActiveTooltip = null;
let rcTooltipHideTimer = null;

function rcHideTooltip() {
  if (rcActiveTooltip) {
    rcActiveTooltip.remove();
    rcActiveTooltip = null;
  }
  if (rcTooltipHideTimer) {
    clearTimeout(rcTooltipHideTimer);
    rcTooltipHideTimer = null;
  }
}

function rcShowTooltip(text, anchorEl) {
  rcHideTooltip();
  if (!text) return;

  const tip = document.createElement('div');
  tip.className = 'rc-tooltip';
  tip.textContent = text;
  document.body.appendChild(tip);

  const anchorRect = anchorEl.getBoundingClientRect();
  const tipRect = tip.getBoundingClientRect();

  let top = anchorRect.top - tipRect.height - 10;
  let left = anchorRect.left + (anchorRect.width / 2) - (tipRect.width / 2);

  if (top < 10) top = anchorRect.bottom + 10;
  if (left < 10) left = 10;
  if (left + tipRect.width > window.innerWidth - 10) left = window.innerWidth - tipRect.width - 10;

  tip.style.top = `${top}px`;
  tip.style.left = `${left}px`;

  rcActiveTooltip = tip;
  rcTooltipHideTimer = setTimeout(rcHideTooltip, 4000);
}

function rcInitTooltips() {
  document.querySelectorAll('[data-tooltip]').forEach(el => {
    const text = el.getAttribute('data-tooltip');
    if (!text) return;

    el.addEventListener('mouseenter', () => rcShowTooltip(text, el));
    el.addEventListener('mouseleave', rcHideTooltip);
    el.addEventListener('focus', () => rcShowTooltip(text, el));
    el.addEventListener('blur', rcHideTooltip);
    el.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (rcActiveTooltip) rcHideTooltip();
      else rcShowTooltip(text, el);
    });
  });

  document.addEventListener('click', (event) => {
    if (rcActiveTooltip && !event.target.closest('[data-tooltip]')) rcHideTooltip();
  });

  document.addEventListener('scroll', rcHideTooltip, { passive: true });
}

rcInitTooltips();

  loadLocations().then(restoreQuote);
  render();
});